import { Pagination } from '../store-interfaces';

export const UIFilterStarterKinds = [
  'all',
  'comment_guard',
  'customer_chat_widget',
  'facebook_optin',
  'facebook_page_welcomer',
  'landing_pages',
  'share_links',
  'instagram_link',
  'sms_keywords',
  'optin_popups',
  'instagram_welcomer',
  'instagram_story_mention',
  'instagram_story_reaction',
  'instagram_comment_guard',
  'instagram_live_comment_guard',
  'instagram_catch_all',
  'facebook_catch_all',
] as const;

// https://stackoverflow.com/a/45486495
type UIFilterStarterKindTuple = typeof UIFilterStarterKinds;
export type UIFilterStarterKindType = UIFilterStarterKindTuple[number];

const countersMock = {
  optin: 4,
  smsKeywords: 28,
  welcomePage: 1,
  landingPage: 14,
  link: 7,
  customerChat: 7,
  checkbox: 4,
  fbCommentGuard: 10,
  sendToMessenger: 3,
};

export type ChatStarterCountersType = typeof countersMock;

export type ChatStarterKindSnakeType =
  | 'all'
  | 'fb_comment_guard'
  | 'customer_chat'
  | 'link'
  | 'instagram_link'
  | 'welcome_page'
  | 'send_to_messenger'
  | 'checkbox'
  | 'landing_page'
  | 'optin'
  | 'sms_keywords'
  | 'instagram_welcomer'
  | 'instagram_story_mention'
  | 'instagram_story_reaction'
  | 'instagram_comment_guard'
  | 'instagram_live_comment_guard'
  | 'instagram_catch_all'
  | 'facebook_catch_all'
  | 'getemails';

export type ChatStarterType = {
  id: number;
  pageId: number;
  kind: ChatStarterKindSnakeType;
  name: string;
  active: boolean;
  createdAt: string;
  starterDateTime: string;
  startsCount: number | null;
  className: 'Promoter' | 'Trigger' | 'LandingPage';
  postId?: number | string;
  subKind?: string;
};

type ChatStartersPaginationType = Pagination & {
  grouped?: ChatStarterCountersType; // this key is only present for 'all' kind query
};

export type ChatStartersPayload = {
  chatStarters: ChatStarterType[];
  pagination: ChatStartersPaginationType;
};
